import React from 'react';

/**
 * 🚨 ЧОРНИЙ ЕКРАН БІЛЬШЕ НЕ МОВЧИТЬ.
 *
 * У React будь-яка помилка під час рендера демонтує все дерево. Без цієї
 * обгортки кабінет ставав порожньою чорною сторінкою, а причина лишалась однією
 * загадковою стрічкою в консолі браузера — і то не завжди. Двічі за день ми
 * витрачали на це час: спершу шукали мережеву проблему, потім CSF, а падіння
 * було в одному рядку JavaScript.
 *
 * Обгортка нічого не лікує — вона робить збій ВИДИМИМ: показує, що саме
 * зламалось, і дає перезавантажити сторінку.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // У консоль — повний слід: він потрібен, коли користувач надсилає скрін.
    console.error('[Кабінет] помилка рендера:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error);
    const proxied = /не JSON|повернулась сторінка/i.test(msg)
      || /is not a function/i.test(msg);
    return (
      <div style={S.wrap}>
        <h2 style={S.h2}>Сторінка не відкрилась</h2>
        <p style={S.lead}>
          {proxied
            ? 'Найімовірніше, сервер саме перезапускається або недоступний — '
              + 'тоді замість даних приходить сторінка, і кабінет не може її показати.'
            : 'Сталася помилка під час побудови сторінки.'}
        </p>
        <pre style={S.pre}>{msg}</pre>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={S.btn} onClick={() => window.location.reload()}>
            Перезавантажити
          </button>
          <button style={{ ...S.btn, ...S.btnGhost }}
                  onClick={() => { window.location.href = '/'; }}>
            На головну
          </button>
        </div>
      </div>
    );
  }
}

const S = {
  wrap: { maxWidth: 720, margin: '60px auto', padding: '24px 26px', color: '#1A1A1A',
          background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: 10,
          fontFamily: "'Inter', system-ui, sans-serif" },
  h2:   { margin: '0 0 8px', fontSize: 20 },
  lead: { margin: '0 0 14px', color: '#5B646F', lineHeight: 1.5 },
  pre:  { background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 6,
          padding: '10px 12px', fontSize: 12.5, color: '#C02B5E',
          whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginBottom: 16 },
  btn:  { padding: '8px 16px', borderRadius: 6, border: '1px solid #475FFA',
          background: '#475FFA', color: '#fff', fontSize: 13.5, cursor: 'pointer' },
  btnGhost: { background: '#FFFFFF', color: '#5B646F', borderColor: '#E5E7EB' },
};
